// extracted by mini-css-extract-plugin
module.exports = {"sectionBtns":"SectionButtons_sectionBtns__2PtbK","sectionBtn":"SectionButtons_sectionBtn__2DFGj","active":"SectionButtons_active__2Mhm7"};